import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';

export default function Subscription() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/subscription').then(r => setData(r.data.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner fullPage />;

  const plan = data?.planId;
  const usage = { users: 0, storage: 0 };

  return (
    <div>
      <PageHeader title="Subscription" icon="bi-credit-card" subtitle="Manage your plan and usage" />
      <div className="row g-3">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">Current Plan</div>
            <div className="card-body">
              <h3 className="fw-bold">{plan?.name}</h3>
              <span className={`badge bg-${plan?.tier === 'enterprise' ? 'warning text-dark' : plan?.tier === 'pro' ? 'primary' : 'secondary'} mb-3`}>{plan?.tier}</span>
              <div className="row g-2 mb-3">
                <div className="col-6"><div className="p-2 bg-light rounded text-center" style={{ fontSize: 12 }}><div className="fw-bold">{plan?.maxUsers === -1 ? '∞' : plan?.maxUsers}</div><div className="text-muted">Max Users</div></div></div>
                <div className="col-6"><div className="p-2 bg-light rounded text-center" style={{ fontSize: 12 }}><div className="fw-bold">{plan?.maxStorageMB === -1 ? '∞' : `${(plan?.maxStorageMB||0)/1024}GB`}</div><div className="text-muted">Storage</div></div></div>
              </div>
              <div style={{ fontSize: 13 }}>
                <div className="fw-semibold mb-2">Included Features:</div>
                <ul className="list-unstyled">
                  {(plan?.features || []).map((f, i) => <li key={i}><i className="bi bi-check2-circle text-success me-2"></i>{f}</li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">Active Modules ({data?.activeModuleIds?.length || 0})</div>
            <div className="card-body p-0" style={{ maxHeight: 400, overflowY: 'auto' }}>
              <ul className="list-group list-group-flush">
                {(data?.activeModuleIds || []).map(mod => (
                  <li key={mod._id || mod} className="list-group-item py-2" style={{ fontSize: 13 }}>
                    <i className={`bi ${mod.icon || 'bi-grid'} me-2`} style={{ color: '#0d6efd' }}></i>
                    {mod.name || mod}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
